/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Spacer, Text } from "@nordcloud/gnui";
import styles from "~/assets/styles/Runbook.module.css";
import { Divider } from "~/components/Styled/Divider";
import { Application } from "~/models";

type Props = {
  application: Application;
};

function AutoBackupConfig({ application }: Props) {
  return (
    <Divider>
      <Spacer height="1rem" />

      <Text isTitle weight="medium">
        AutoBackup configuration
      </Text>

      {application?.abConfigurations?.length < 1 ? (
        <Text mt={3}>No AutoBackup configurations</Text>
      ) : (
        <>
          <div className={styles.columnsContainer}>
            <span className={styles.tableHeader}>Customer name</span>
            <span className={styles.tableHeader}>Setup</span>
            <span className={styles.tableHeader}>Policy</span>
            <span className={styles.tableHeader}>Resources</span>
          </div>

          {application?.abConfigurations?.map((ab, index) => (
            <div key={index} className={styles.columnsContainer}>
              <p className={styles.tableElement}>{ab?.customerName}</p>
              <p className={styles.tableElement}>{ab?.setup}</p>
              <p className={styles.tableElement}>{ab?.policy}</p>
              <p className={styles.tableElement}>-</p>
            </div>
          ))}
        </>
      )}

      <Spacer height="1rem" />
    </Divider>
  );
}

export { AutoBackupConfig };
